"use strict";

var _omegaTrackerLite = _interopRequireDefault(require("@didi/omega-tracker-lite"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// 前端h5页面用
var _info = {};
var _langs = {};
var _lang = 'en-us';
var _isDev;
function i18nInit(info) {
  _info = info;
}

// merge 热更新的文案和本地文案
function i18nGet(langText, langType) {
  try {
    if (/^ar/.test((langType || '').toLowerCase())) {
      window.i18nArabicRTL = true;
      document.body.setAttribute('class', "".concat((document.body.getAttribute('class') || '').replace(/i18n-Arabic-rtl/g, ''), " i18n-Arabic-rtl").replace(/(^\s+|\s+$)/g, ''));
    }
    if (!window.i18nPluginH5DiffCopywriter || !langType) {
      return langText;
    }
    var langDiff = window.i18nPluginH5DiffCopywriter[langType.toLowerCase().replace('-', '_')];
    if (!langDiff) return langText;
    Object.keys(langDiff).forEach(function (key) {
      var value = langDiff[key];
      if (typeof _info.placeholder !== 'undefined') {
        var _info$placeholder;
        var marker = (_info$placeholder = _info.placeholder) === null || _info$placeholder === void 0 ? void 0 : _info$placeholder.split(/%s/);
        langDiff[key] = value.replace(/\{\{(.+?)\}\}/g, "".concat(marker[0], "$1").concat(marker[1]));
      }
      if (_info.prefix && new RegExp(_info.prefix).test(key)) {
        langDiff[key.replace(_info.prefix, '')] = value;
        delete langDiff[key];
      }
    });
    var _walk = function walk(obj, keyStr, value) {
      var keyArr = _info.noParse ? [keyStr] : keyStr.split('.');
      if (keyArr.length === 1) {
        Object.assign(obj, _defineProperty({}, keyStr, value === '[]' ? [] : value));
      } else {
        if (!obj[keyArr[0]]) obj[keyArr[0]] = {};
        Object.assign(obj[keyArr[0]], _walk(obj[keyArr[0]], keyArr.slice(1).join('.'), value));
      }
      return obj;
    };

    // eslint-disable-next-line array-callback-return
    Object.keys(langDiff).map(function (keyStr) {
      if (langDiff[keyStr] !== '') {
        _walk(langText, keyStr, langDiff[keyStr]);
      }
    });
  } catch (e) {
    console.log('i18n-plugin-error:', e);
  }
  return langText;
}

// 热更新用
function i18nLoading(errCallback) {
  return new Promise(function (resolve) {
    var retryCount = 1;
    var interval = setInterval(function () {
      if (window.i18nPluginH5DiffCopywriterLoaded) {
        clearInterval(interval);
        if (window.i18nPluginH5DiffCopywriterLoaded !== 'success') {
          errCallback(window.i18nPluginH5DiffCopywriterLoaded);
        }
        resolve();
      } else {
        retryCount++;
        window.loadTime = retryCount * 100 + 100;
        if (retryCount >= 100) {
          clearInterval(interval);
          errCallback('timeout');
          resolve();
        }
      }
    }, 100);
  });
}
module.exports.i18nInit = i18nInit;
module.exports.i18nGet = i18nGet;
module.exports.i18nLoading = i18nLoading;

// 见文档 http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=294732154
module.exports.i18nStart = function (entry, info, langs) {
  i18nInit(info);
  _langs = entry;
  _isDev = !!langs;
  if (!_isDev) return;
  var failedLangs = [];
  langs.forEach(function (lang, i) {
    lang = lang.replace('_', '-').toLowerCase();
    if (!i) _lang = lang;
    if (!entry[lang]) {
      failedLangs.push(lang);
    }
  });
  if (failedLangs.length > 0) {
    fetch("http://localhost:12122?langs=".concat(failedLangs.join(',')));
  }
};
module.exports.i18nSetLang = function (lang) {
  _lang = lang.replace('_', '-').toLowerCase();
  if (/^ar/.test(_lang)) {
    window.i18nArabicRTL = true;
    document.body.setAttribute('class', "".concat((document.body.getAttribute('class') || '').replace(/i18n-Arabic-rtl/g, ''), " i18n-Arabic-rtl").replace(/(^\s+|\s+$)/g, ''));
  }
  if (_isDev && !_langs[_lang]) {
    fetch("http://localhost:12122?langs=".concat(_lang));
  }
};
var I18nTrack = /*#__PURE__*/function () {
  function I18nTrack(omega) {
    _classCallCheck(this, I18nTrack);
    this._keys = [];
    this.timeout = null;
    this.omega = omega;
  }

  // 文案上传omega
  return _createClass(I18nTrack, [{
    key: "handleTrack",
    value: function handleTrack() {
      try {
        var _this$_keys, _this$omega, _this$omega$trackEven, _info2, _info3, _info4;
        var curKeys = (_this$_keys = this._keys) === null || _this$_keys === void 0 ? void 0 : _this$_keys.splice(0);
        var omgObj = {};

        // 格式化数据
        curKeys.forEach(function (key) {
          if (omgObj[key]) {
            omgObj[key] += 1;
          } else {
            omgObj[key] = 1;
          }
        });

        // 上报
        (_this$omega = this.omega) === null || _this$omega === void 0 || (_this$omega$trackEven = _this$omega.trackEvent) === null || _this$omega$trackEven === void 0 || _this$omega$trackEven.call(_this$omega, 'tech_i10n_keys', '文案key', {
          module: (_info2 = _info) === null || _info2 === void 0 ? void 0 : _info2.moduleName,
          project: "".concat((_info3 = _info) === null || _info3 === void 0 ? void 0 : _info3.moduleName).concat((_info4 = _info) === null || _info4 === void 0 ? void 0 : _info4.filePath),
          use_count: JSON.stringify(omgObj),
          submit_time: new Date().getTime()
        });
      } catch (e) {
        console.log('i18n-plugin-error:', e);
      }
    }
  }, {
    key: "addKeys",
    value: function addKeys(key) {
      var _this$_keys2,
        _this = this;
      (_this$_keys2 = this._keys) === null || _this$_keys2 === void 0 || _this$_keys2.push(key);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this.handleTrack();
      }, 500);
    }
  }]);
}();
var track = null;
var getTracker = function getTracker() {
  if (track === null) {
    // 生成新的omega实例
    var omega = _omegaTrackerLite["default"] === null || _omegaTrackerLite["default"] === void 0 ? void 0 : _omegaTrackerLite["default"].getTracker({
      appKey: 'omega01ea7e2e23',
      uploadHost: 'omgup.didiglobal.com'
    });

    // 生成上报omega实例
    track = new I18nTrack(omega);
  }
  return track;
};
module.exports.i18nTranslate = function (key, data) {
  var text = i18nGet(_langs[_lang]["default"] || _langs[_lang], _lang)[key];

  // 配置 noOmega 则不初始化 omega
  var tracker = !_info.noOmega && getTracker();
  if (text) {
    var _tracker$addKeys;
    // 统计文案key 触发轮询
    tracker === null || tracker === void 0 || (_tracker$addKeys = tracker.addKeys) === null || _tracker$addKeys === void 0 || _tracker$addKeys.call(tracker, key);
    // 替换占位符   i18nTranslate('hfieahfaoefj{{d1}}feafa{{d2}}', {d1: '1', d2:'2'})
    return _typeof(data) === 'object' ? text.replace(new RegExp("(".concat(Object.keys(data).map(function (k) {
      return "{{\\s*".concat(k, "\\s*}}");
    }).join('|'), ")"), 'g'), function (v) {
      return data[v.slice(2, -2).replace(/(^\s+|\s+$)/g, '')];
    }) : text;
  }
  if (_isDev) {
    fetch("http://localhost:12122?keys=".concat(key));
  }
};